import { supabase } from "@/src/common/services/supabase.service";

export interface NotificationPreferences {
	userId: string;
	feed: boolean;
	jobs: boolean;
	studentCentral: boolean;
	messaging: boolean;
}

/** Sensible defaults used when a user has never saved a row. */
export const defaultPreferences: Omit<NotificationPreferences, "userId"> = {
	feed: true,
	jobs: true,
	studentCentral: true,
	messaging: true,
};

export const notificationsService = {
	async get(userId: string): Promise<NotificationPreferences> {
		const { data, error } = await supabase
			.from("user_notification_preferences")
			.select("user_id, feed, jobs, student_central, messaging")
			.eq("user_id", userId)
			.maybeSingle();
		if (error) throw new Error(error.message);
		if (!data) return { userId, ...defaultPreferences };
		return {
			userId: data.user_id,
			feed: data.feed,
			jobs: data.jobs,
			studentCentral: data.student_central,
			messaging: data.messaging,
		};
	},

	async upsert(prefs: NotificationPreferences): Promise<NotificationPreferences> {
		const { data, error } = await supabase
			.from("user_notification_preferences")
			.upsert(
				{
					user_id: prefs.userId,
					feed: prefs.feed,
					jobs: prefs.jobs,
					student_central: prefs.studentCentral,
					messaging: prefs.messaging,
				},
				{ onConflict: "user_id" },
			)
			.select("user_id, feed, jobs, student_central, messaging")
			.single();
		if (error) throw new Error(error.message);
		return {
			userId: data.user_id,
			feed: data.feed,
			jobs: data.jobs,
			studentCentral: data.student_central,
			messaging: data.messaging,
		};
	},
};
